export default __webpack_public_path__ + "static/homelife-8064401dcb1847d7a3bf2f7d428cdf81.png";